import axios from '../CustomAxios';
import { socket } from '../sockets/socket';
import { LOGIN_USER, LOGOUT, LOAD_USER } from './types';

const sendRequest = async (query) => {
  const config = {
    headers: {
      'x-auth-token': query.verification,
    },
  };
  const res = await axios.post(
    `/api/v1/${query.type}/auth/login/2fa`,
    {
      email_address: query.email_address,
      otp_code: query.otp_code,
    },
    config
  );
  return res.data;
};

async function getCurrentGeoLocation() {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve(position);
      },
      (err) => {
        reject('Please allow location service for this site');
      }
    );
  });
}

const getUser = async (userData) => {
  const config = {
    headers: {
      Authorization: 'Bearer ' + userData.access_token,
    },
  };

  if ('geolocation' in navigator) {
    const sessionKey = sessionStorage.getItem('ap-session-id');
    if (sessionKey && sessionKey?.length > 0) {
      config.headers.session_key = 'AP__' + sessionKey;
    }

    const response = await getCurrentGeoLocation();
    const machinePlatform = navigator.platform.toString();
    const browserAgent = navigator.userAgent.toString();

    let api_path_url = null;
    switch (userData.type) {
      case 'super_admin':
        api_path_url = '/api/v1/super_admin/my';
        break;
      case 'ap_user':
        api_path_url = `/api/v1/ap_user/${userData.user_id}/my`;
        break;
      case 'customer_user':
        api_path_url = `/api/v1/customer_user/${userData.user_id}/my`;
        break;
      default:
        return;
    }

    const { data: apiResponse } = await axios.get(
      `${api_path_url}?browser_agent=${browserAgent}&platform=${machinePlatform}&location_enabled=YES&latitude=${response.coords?.latitude}&longitude=${response.coords?.longitude}`,
      config
    );
    sessionStorage.setItem('ap-session-id', apiResponse?.data?.sessions?.session_key);
    return apiResponse;
  } else {
    alert('Your browser does not support Geo Location Service !!');
    return;
  }
};

export const loadUser = () => async (dispatch) => {
  try {
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    if (!authData) {
      return;
    }
    const data = await getUser(authData);
    if (data.success) {
      if (data.data?.sessions?.session_key) {
        socket.emit('assign_session_key', {
          session_key: data.data.sessions?.session_key,
          user_id: authData.user_id,
          user_type: authData.type,
        });
      }
      return dispatch({
        success: true,
        type: LOAD_USER,
        payload: data.data,
      });
    } else {
      return { success: false, message: 'Failed to Load User' };
    }
  } catch (e) {
    console.log(e);
    return { success: false, message: 'Erorr in loading user' };
  }
};

const superAdminRequest = async (query) => {
  const res = await axios.post(`/api/v1/super_admin/auth/login`, {
    email_address: query.email_address,
    password: query.password,
  });
  return res.data;
};

export const loginUser = (user) => async (dispatch) => {
  try {
    if (user.type === 'super_admin') {
      const query = {
        email_address: user.email_address,
        password: user.password,
        type: user.type,
      };
      const data = await superAdminRequest(query);
      if (!data.success) {
        return { success: false, message: 'Failed to Login' };
      }
      return dispatch({
        success: true,
        type: LOGIN_USER,
        payload: {
          access_token: data.data.access_token,
          user_id: data.data.user_details._id,
          type: user.type,
        },
      });
    } else {
      const query = {
        email_address: user.email_address,
        otp_code: user.otp_code,
        verification: user.verification,
        type: user.type,
      };
      const data = await sendRequest(query);
      if (!data.success) {
        return { success: false, message: 'Failed to Login' };
      }
      return dispatch({
        success: true,
        type: LOGIN_USER,
        payload: {
          access_token: data.data.access_token,
          user_id: data.data.user_details._id,
          type: user.type,
        },
      });
    }
  } catch (e) {
    return {
      success: false,
      message: e.response.data.error || 'Server Error',
    };
  }
};

export const logout = () => {
  emitNormalLogoutEvent();
  return {
    type: LOGOUT,
  };
};

async function emitNormalLogoutEvent() {
  try {
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    const sessionKey = sessionStorage.getItem('ap-session-id');
    const response = await getCurrentGeoLocation();
    const sessionData = {
      session_key: sessionKey,
      user_id: authData.user_id,
      user_type: authData.type,
      coordinates: {
        latitude: response.coords?.latitude || 0,
        longitude: response.coords?.longitude || 0,
      },
    };
    socket.emit('deactivate_user_session', sessionData);
    sessionStorage.clear();
    localStorage.clear();
  } catch (e) {
    console.log(e);
  }
}
